import get from 'lodash/get'

export const getLoading = state => get(state, 'configUpdate.isLoading', false)
export const getSelectedChargers = state => get(state, 'configUpdate.data.selectedChargers', 0)
export const getAvailableForUpdate = state => get(state, 'configUpdate.data.availableForUpdate', 0)
export const getSelectedChargerIds = state => get(state, 'configUpdate.data.selectedChargerIds', [])
